import { PayableAmountItem, PayableAmounts } from '@libs/api-reference';
import { computed } from 'vue';
import { useQueryV2 } from '@libs/use';

import * as API from '../requests';
import { CASH_QUERY_KEYS } from '../constants';

export default function usePayableAmountsQuery() {
  const {
    result,
    execute: getPayableAmounts,
    isPending: isLoadingPayableAmounts,
    isRevalidating: isRevalidatingPayableAmounts,
  } = useQueryV2<PayableAmounts>(API.getPayableAmounts, {
    key: CASH_QUERY_KEYS.payableAmounts,
    staleTime: 1000,
  });

  const payableAmounts = computed<PayableAmountItem[]>(() =>
    Object.values<PayableAmountItem>(result.value?.data || {})
  );

  return {
    getPayableAmounts,
    payableAmounts,
    isLoadingPayableAmounts,
    isRevalidatingPayableAmounts,
  };
}
